<template>
  <Nav />
  <div class="container">
    <div class="container-header" v-if="exercicioSelected">
      <a href="#" class="h3" @click.prevent="exercicioSelected = false">
        <i class="bi bi-arrow-left"></i>
      </a>
      <div class="exercicios-title align-center">
        <p class="h3 poppins-light analises-title">CAPAG</p>
        <p class="h4 poppins-light exercicio-text">
          Exercício <span class="poppins-semibold">{{ exercicio }}</span>
        </p>
      </div>
      <div class="export-analise">
        <a href="#" @click="openExportnModal" v-if="linkPrint">
          Exportar análises<i
            class="bi bi-download"
            style="margin-left: 5px"
          ></i>
        </a>
      </div>
    </div>
    <div class="container-exercicio">
      <div
        class="exercicios-header align-left"
        v-if="!exercicioSelected && Object.keys(entidadeExercicios).length > 0 && !isLoadingPage"
      >
        <h1 class="h3 mb-3 poppins-light">
          Selecione o <span class="poppins-semibold">Exercício CAPAG</span>
        </h1>
      </div>
      <div
        class="exercicios-list"
        v-if="!exercicioSelected && Object.keys(entidadeExercicios).length > 0 && !isLoadingPage"
      >
        <ul class="list-group">
          <li
            v-for="[key, value] in sortedEntidadeExercicios"
            :key="key"
            class="list-group-item"
          >
            <a href="#" @click.prevent="setContext(key, value)">
              {{ key }}
              <i class="bi bi-arrow-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <div
        class="no-exercicios-message"
        v-if="
          Object.keys(entidadeExercicios).length === 0 && !exercicioSelected && !isLoadingPage
        "
      >
        <h4 class="poppins-light">Não há análises CAPAG para este município</h4>
      </div>
    </div>
  </div>
  <div class="iframe-analise" v-if="exercicioSelected">
    <!-- Button to trigger the print -->
    <div class="iframe-analise-header"></div>
    <iframe
      width="1300"
      height="1550"
      id="iframe-report"
      :src="linkIframe"
    ></iframe>
    <div class="iframe-analise-footer"></div>
  </div>
  <div
    class="modal modal-lg fade"
    id="confirmationExport"
    tabindex="-1"
    aria-labelledby="confirmationExportLabel"
    :inert="!isModalVisible"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationExportLabel">
            Exportar CAPAG
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row mb-2">
            <div class="col-md-12">
              <span class="poppins-semibold" style="padding-right: 10px"
                >Selecione as análises CAPAG para exportar:</span
              >
              <a href="#" @click.prevent="selectAllMonths">Todos</a> |
              <a href="#" @click.prevent="unselectAllMonths">Nenhum</a>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4" v-for="month in monthsToExport" :key="month">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="month"
                  v-model="selectedMonths"
                  :id="`inlineCheckbox${month}`"
                />
                <label
                  class="form-check-label"
                  :for="`inlineCheckbox${month}`"
                  >{{ month }}</label
                >
              </div>
            </div>
          </div>
          <div class="row mt-4 mb-2">
            <div class="col-md-12">
              <div class="email-input-container">
                <label
                  for="inputEmailExport"
                  class="form-label poppins-semibold"
                  >Digite o(s) email(s) para receber as análises CAPAG:</label
                >
                <input
                  type="text"
                  v-model="emailExport"
                  placeholder="Digite um email e pressione Enter"
                  class="form-control"
                  id="inputEmailExport"
                  @keyup.enter="addEmail"
                  @keyup.space="addEmail"
                  @blur="addEmail"
                />
                <div
                  v-for="email in emailExportList"
                  :key="email"
                  class="email-tag mt-2"
                >
                  {{ email }}
                  <span @click="removeEmail(email)" class="remove-email"
                    >&times;</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-bs-dismiss="modal"
              :disabled="exportAnalisesConfirmed"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="confirmExport"
              :disabled="
                exportAnalisesConfirmed ||
                selectedMonths.length === 0 ||
                emailExportList.length === 0
              "
              style="margin-left: 10px"
            >
              Confirmar
            </button>
          </div>
          <div class="row width-100" v-if="exportAnalisesConfirmed">
            <div class="col-md-12">
              <div class="alert alert-secondary" role="alert">
                As análises CAPAG estão sendo exportadas em segundo plano, você
                será notificado do resultado, aguarde...
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/axios";
import { buscarEmailsCache, salvarEmailsCache } from "@/utils/exportEmailCache";
import axios from "axios";
import Nav from "@/components/Nav.vue";
import Cookies from "js-cookie";
import { mapActions } from "vuex";
// Modal is available via window.bootstrap from CDN
import qs from "qs";

export default {
  name: "AnalisesCAPAG",
  data() {
    return {
      entidadeExercicios: {},
      isLoadingPage: true,
      exercicioSelected: false,
      linkIframe: "",
      linkPrint: "",
      exercicio: "",
      showExportModal: false,
      email: "",
      selectedNumbers: [],
      isModalVisible: false,
      emailExport: "",
      emailExportList: [],
      monthsToExport: [
        "CAPAG",
        "Apontamentos",
        "Suficiência de Caixa",
        "Suficiência de Caixa FRs",
        "CAPAG x Ano Ant.",
        "CAPAG Sazonal",
        "CAPAG Histórico",
        "CAPAG MSC x RGF/DCA",
        "Suficiência de Caixa MSC x RGF/DCA"
      ],
      selectedMonths: [],
      exportAnalisesConfirmed: false,
      exportAnalisesResult: "",
      exportAnalisesResultError: false,
      cidadeSelected: "",
    };
  },
  async created() {
    try {
      await this.validateToken();
      this.checkUserEntidade();
      const userEntidade = Cookies.get("user-entidade");
      const cookieString = userEntidade.split(`j:`)[1];
      const userEntidadeJson = JSON.parse(cookieString);
      this.codigoSiconfi = userEntidadeJson.codigo_siconfi;
      this.cidadeSelected = userEntidadeJson.cidade;
      this.email = userEntidadeJson.email;
      const entidadeResponse = await axiosApi.get(
        `/api/entidades/${this.codigoSiconfi}`,
        {
          withCredentials: true,
        }
      );

      const entidade = entidadeResponse.data.data;
      // Filter exercicios to only show those with CAPAG data
      this.entidadeExercicios = this.filterCapagExercicios(entidade.exercicios);
      this.isLoadingPage = false;
    } catch (error) {
      console.log(error);
      this.handleUnauthenticated();
    }
  },
  methods: {
    ...mapActions(["validateToken", "showToast"]),
    checkUserEntidade() {
      if (!this.$store.state.userEntidade) {
        this.$router.push("/selecaoEntidades");
      }
    },
    filterCapagExercicios(exercicios) {
      const filtered = {};
      for (const [key, value] of Object.entries(exercicios)) {
        // Only include exercicios that have CAPAG data
        if (value.report_capag || value.print_capag) {
          filtered[key] = {
            ...value,
            // Use CAPAG links instead of regular links
            report: value.report_capag || "",
            print: value.print_capag || "",
          };
        }
      }
      return filtered;
    },
    setContext(key, value) {
      this.linkIframe = "";
      this.linkPrint = "";
      // Use CAPAG links
      this.linkIframe = value.report_capag;
      this.linkPrint = value.print_capag;
      this.exercicioSelected = true;
      this.exercicio = key;
      /* Sem await: a auditoria de acesso não pode atrasar nem impedir a exibição do relatório. */
      this.registrarAcesso(key);
    },
    async registrarAcesso(ano) {
      try {
        await axiosApi.post("/api/relatorios/acesso", {
          codigo_siconfi: this.codigoSiconfi,
          ano,
          tipo: "CAPAG",
        });
      } catch (error) {
        console.error("Error registering access audit log:", error);
      }
    },
    handleUnauthenticated() {
      this.$router.push("/login");
    },
    printIframeContent() {
      const linkIframe = this.linkIframe;
      const printWindow = window.open(
        `/print-iframe?linkIframe=${encodeURIComponent(linkIframe)}`,
        "_blank",
        "width=1300,height=1550"
      );
      printWindow.focus();
    },
    openExportnModal() {
      const emailsCache = buscarEmailsCache(this.email, this.codigoSiconfi, this.exercicio);
      this.emailExportList = emailsCache ?? [this.email];
      this.isModalVisible = true;
      const modal = new window.bootstrap.Modal(
        document.getElementById("confirmationExport")
      );
      modal.show();
      modal._element.addEventListener("hidden.bs.modal", () => {
        this.isModalVisible = false;
      });
    },
    async confirmExport() {
      /* Grava antes do export: o timer de 7s e o fechamento do modal disparam resetModal(),
         que zera emailExportList antes de o print responder. */
      salvarEmailsCache(this.email, this.codigoSiconfi, this.exercicio, this.emailExportList);
      this.exportAnalisesConfirmed = true;
      setTimeout(() => {
        this.isModalVisible = false;
        const modal = window.bootstrap.Modal.getInstance(
          document.getElementById("confirmationExport")
        );
        modal.hide();
      }, 7000);
      await this.exportAnalises();
    },
    async exportAnalises() {
      const selectedMonths = this.selectedMonths;
      const emails = this.emailExportList;

      try {
        await axiosApi.post("/api/relatorios/gerar", {
          codigo_siconfi: this.codigoSiconfi,
          ano: this.exercicio,
          tipo: "CAPAG",
          meses: selectedMonths,
          emails: emails,
        });
      } catch (error) {
        console.error("Error registering CAPAG export audit log:", error);
      }

      try {
        const response = await axios.get(this.linkPrint, {
          params: {
            emails: emails,
            meses: selectedMonths,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });

        this.exportAnalisesConfirmed = false;

        if (response.data.success === true) {
          this.exportAnalisesResultError = false;
        } else {
          this.exportAnalisesResultError = true;
        }

        this.exportAnalisesResult = `${response.data.message} (${
          this.cidadeSelected
        } - ${selectedMonths.join(", ")})`;

        const toastElement = this.exportAnalisesResultError
          ? "Fail"
          : "Success";
        this.showExportToast(toastElement, this.exportAnalisesResult);
      } catch (error) {
        console.error("Error exporting CAPAG analyses:", error);
        this.exportAnalisesConfirmed = false;
        this.exportAnalisesResultError = true;
        this.exportAnalisesResult = "Erro ao gerar relatório CAPAG. Tente novamente.";
        this.showExportToast("Fail", this.exportAnalisesResult);
      }
    },
    showExportToast(element, message) {
      const toastType = element === "Fail" ? "toast-danger" : "toast-success";
      const headerClass =
        element === "Fail" ? "toast-header-danger" : "toast-header-success";
      this.showToast({
        title: "Resultado da exportação CAPAG",
        message: message,
        type: toastType,
        headerClass: headerClass,
      });
    },
    addEmail() {
      const email = this.emailExport.trim();
      if (email && !this.emailExportList.includes(email)) {
        this.emailExportList.push(email);
      }
      this.emailExport = "";
    },
    removeEmail(email) {
      this.emailExportList = this.emailExportList.filter((e) => e !== email);
    },
    selectAllMonths() {
      this.selectedMonths = [
        ...this.monthsToExport,
      ];
    },
    unselectAllMonths() {
      this.selectedMonths = [];
    },
    resetModal() {
      this.emailExport = "";
      this.emailExportList = [];
      this.selectedMonths = [];
      this.exportAnalisesResult = "";
      this.exportAnalisesResultError = false;
      this.exportAnalisesConfirmed = false;
    },
  },
  computed: {
    sortedEntidadeExercicios() {
      return Object.entries(this.entidadeExercicios).sort((a, b) => parseInt(b[0]) - parseInt(a[0]));
    },
  },
  watch: {
    exercicioSelected(newVal) {
      if (!newVal) {
        this.linkPrint = "";
      }
    },
    isModalVisible(newVal) {
      if (!newVal) {
        this.resetModal();
      }
    },
  },
  components: {
    Nav,
  },
};
</script>

<style>
.container-exercicio {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding-bottom: 0;
  width: 100%;
}

.container-header {
  min-width: 1280px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
}

.container-header a {
  margin: 0;
}

.breadcrumb {
  margin-bottom: 20px;
  font-size: 1rem;
}

.breadcrumb a {
  color: var(--azul-final);
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.exercicios-list {
  margin: 0 auto;
  width: 100%;
  max-width: 720px;
}

.exercicios-list ul {
  list-style-type: none;
  padding: 0;
  /* min-width: 800px; */
}

.exercicios-list ul li a {
  /* background-color: aqua; */
  padding: 10px;
  display: flex;
  width: 100%;
  color: var(--azul-final);
  transition: background-color 0.5s;
  font-size: 1.2rem;
}
.exercicios-list ul li a i {
  right: 15px;
  position: absolute;
}
.exercicios-list ul li a:hover {
  background-color: var(--azul-claro);
  color: white;
  font-weight: 600;
}

.exercicios-list ul li {
  padding: 0;
}

.iframe-analise {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* min-width: 1000px; */
  margin: 0 auto;
  height: 100%;
}

.iframe-analise-footer {
  height: 36px;
  width: 1300px;
  margin-top: -36px;
  background-color: white;
  z-index: 1;
}

.iframe-analise-header {
  height: 27px;
  width: 1300px;
  margin-bottom: -27px;
  background-color: white;
  z-index: 1;
}

.exercicios-title{
  width: 100%;
}

.exercicios-title p {
  margin-bottom: 0;
  padding-bottom: 0;
}

.iframe-analise iframe {
  background-color: rgb(164, 164, 164);
  background-image: url("../assets/bg-carregando.gif");
  background-repeat: no-repeat;
  background-size: 20vh;
  background-position: center;
  background-position-y: 15%;
}

.export-analise {
  width: 100%;
  max-width: 1300px;
  display: flex;
  justify-content: flex-end;
  font-size: 1.2rem;
}

.export-analise a:hover,
.export-analise a:active {
  text-decoration: underline;
}

.modal-body a:hover,
.modal-body a:active {
  text-decoration: underline;
}

.modal-footer .width-100 {
  width: 100%;
}

.email-input-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.email-tag {
  /* background-color: #e0e0e0; */
  background-color: var(--azul-escuro);
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

.remove-email {
  color: white;
  margin-left: 5px;
  cursor: pointer;
  font-weight: bold;
}

.toast-header-success {
  background-color: #d8ffd8;
}
.toast-header-danger {
  background-color: #ffdada;
}
.toast-success {
  background-color: #00a000;
}
.toast-danger {
  background-color: #ff2c2c;
}
.toast-body {
  color: white;
}

.no-exercicios-message {
  margin: 0 auto;
}
</style>
